<blockquote ngSkipHydration class="instagram-media" [attr.data-instgrm-permalink]="'https://www.instagram.com/p/'+code+'/'" data-instgrm-version="14"></blockquote>
